import {FC, ReactElement} from 'react';
import {GUTTER} from "../../../constants";
import {Card, Col, Row} from "antd";
import {Transcript} from "../components/ConversationStory/TranscriptModal";
import {FeedbackRowProps} from "./types";

export const ConversationElicitRow: FC<FeedbackRowProps> = ({attemptId, style}): ReactElement => (
    <Row gutter={GUTTER} style={style}>
        <Col xs={24}>
            <Card style={{maxHeight: 600, overflowY: 'auto'}}>
                <Row justify='center'>
                    {attemptId !== undefined && <Transcript attemptId={attemptId}/>}
                </Row>
            </Card>
        </Col>
    </Row>
);
